import { includes } from 'lodash';
import { InferGetStaticPropsType } from 'next';

import { REVALIDATE } from '~/constants/revalidate';
import { AgencyLayout } from '~/layouts/AgencyLayout';
import { getAllAgencies } from '~/lib/graphcms/get-all-agencies';
import { AgenciesListSection } from '~/old-marketing/components/agency/AgenciesListSection';
import { AgencyFormCallToActionSection } from '~/old-marketing/components/agency/AgencyFormCallToActionSection';
import { AgencyHeader } from '~/old-marketing/components/agency/AgencyHeader';
import { AgencyHero } from '~/old-marketing/components/agency/AgencyHero';
import { CuratedAgenciesSection } from '~/old-marketing/components/agency/CuratedAgenciesSection';
import { AgencyFavoriteIds } from '~/old-marketing/constants/AgencyFavoriteIds';

export const getStaticProps = async () => {
  const agenciesSet1 = await getAllAgencies({ limit: 1000 });
  const agenciesSet2 = await getAllAgencies({ skip: 1000, limit: 1000 });
  const agencies = [...(agenciesSet1 ?? []), ...(agenciesSet2 ?? [])];

  return {
    props: {
      agencies: agencies,
    },
    revalidate: REVALIDATE,
  };
};

export default function AgenciesPage({ agencies }: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <>
      <AgencyHeader tx={{ zIndex: 2, position: 'absolute', top: 0, left: 0, right: 0, color: 'white' }} />
      <AgencyHero />
      <CuratedAgenciesSection
        agencies={agencies
          ?.filter((agency) => includes(AgencyFavoriteIds, agency.id))
          .sort((a, b) => {
            return AgencyFavoriteIds.indexOf(a.id) - AgencyFavoriteIds.indexOf(b.id);
          })}
      />
      <AgenciesListSection agencies={agencies} />
      <AgencyFormCallToActionSection />
    </>
  );
}

AgenciesPage.layout = AgencyLayout;
